/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { QuoteTestExpectationMetadata } from "./QuoteTestExpectationMetadata";
import {
  QuoteTestExpectationMetadataFromJSON,
  QuoteTestExpectationMetadataFromJSONTyped,
  QuoteTestExpectationMetadataToJSON,
  QuoteTestExpectationMetadataToJSONTyped,
} from "./QuoteTestExpectationMetadata";
import type { QuoteTestExpectationType } from "./QuoteTestExpectationType";
import {
  QuoteTestExpectationTypeFromJSON,
  QuoteTestExpectationTypeFromJSONTyped,
  QuoteTestExpectationTypeToJSON,
  QuoteTestExpectationTypeToJSONTyped,
} from "./QuoteTestExpectationType";

/**
 *
 * @export
 * @interface QuoteTestExpectationDto
 */
export interface QuoteTestExpectationDto {
  /**
   *
   * @type {string}
   * @memberof QuoteTestExpectationDto
   */
  expectationId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof QuoteTestExpectationDto
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExpectationDto
   */
  createdBy?: string;
  /**
   *
   * @type {QuoteTestExpectationType}
   * @memberof QuoteTestExpectationDto
   */
  type?: QuoteTestExpectationType;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExpectationDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestExpectationDto
   */
  metadata?: string;
  /**
   *
   * @type {QuoteTestExpectationMetadata}
   * @memberof QuoteTestExpectationDto
   */
  parsedMetadata: QuoteTestExpectationMetadata;
}

/**
 * Check if a given object implements the QuoteTestExpectationDto interface.
 */
export function instanceOfQuoteTestExpectationDto(
  value: object,
): value is QuoteTestExpectationDto {
  if (!("parsedMetadata" in value) || value["parsedMetadata"] === undefined)
    return false;
  return true;
}

export function QuoteTestExpectationDtoFromJSON(
  json: any,
): QuoteTestExpectationDto {
  return QuoteTestExpectationDtoFromJSONTyped(json, false);
}

export function QuoteTestExpectationDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteTestExpectationDto {
  if (json == null) {
    return json;
  }
  return {
    expectationId:
      json["expectationId"] == null ? undefined : json["expectationId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    type:
      json["type"] == null
        ? undefined
        : QuoteTestExpectationTypeFromJSON(json["type"]),
    description: json["description"] == null ? undefined : json["description"],
    metadata: json["metadata"] == null ? undefined : json["metadata"],
    parsedMetadata: QuoteTestExpectationMetadataFromJSON(
      json["parsedMetadata"],
    ),
  };
}

export function QuoteTestExpectationDtoToJSON(
  json: any,
): QuoteTestExpectationDto {
  return QuoteTestExpectationDtoToJSONTyped(json, false);
}

export function QuoteTestExpectationDtoToJSONTyped(
  value?: QuoteTestExpectationDto | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    expectationId: value["expectationId"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
    type: QuoteTestExpectationTypeToJSON(value["type"]),
    description: value["description"],
    metadata: value["metadata"],
    parsedMetadata: QuoteTestExpectationMetadataToJSON(value["parsedMetadata"]),
  };
}
